<section
  class="flex flex-col items-center justify-between space-y-6 text-center text-slate-900 p-8 tablet-sm:p-20 w-fit mx-auto"
  role="status"
  aria-live="polite"
  *transloco="let t; scope: scope; read: scope"
>
  <!-- Email verified animation -->

  <div class="relative h-32 w-32 flex items-center justify-center" style="perspective: 300px">
    <!-- Letter/Envelope -->

    <!-- Checkmark (appears from letter) -->
    <svg
      class="absolute h-24 w-24 opacity-0 animate-checkmark-appear"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle cx="50" cy="50" r="45" fill="#11C081" />
      <path
        d="M 30 50 L 45 65 L 70 35"
        stroke="white"
        stroke-width="6"
        stroke-linecap="round"
        stroke-linejoin="round"
        fill="none"
      />
    </svg>
  </div>
  <div class="flex flex-col items-center gap-4 justify-center">
    <div class="space-y-4 pt-10 pb-20">
      <p class="text-2xl font-averta-semibold uppercase">{{ t("verified.title") }}</p>
      <p class="text-base font-calibre-regular text-font_grey_primary max-w-md">
        {{ t("verified.message", { email: email }) }}
      </p>
    </div>

    <a
      class="bg-yellow w-full px-4 py-2 rounded-md font-averta-semibold hover:bg-opacity-60"
      [routerLink]="'/login'"
      tabindex="0"
      aria-label="{{ t('verified.button') }}"
    >
      {{ t("verified.button") }}
    </a>
  </div>
</section>
